// ─── ÁREA DO CLIENTE — AUTH STORE ─────────────────────────────────────────────
// Sprint 3.8. Espelha `auth.store.ts` (Zustand + persist em localStorage), mas
// guarda a sessão da Pessoa (cliente) — deliberadamente um store separado do
// `useAuthStore` (equipe interna), pra nunca misturar as duas sessões na
// mesma aba/navegador (ex.: um funcionário logado como User não pode "virar"
// Pessoa sem querer, e vice-versa).
// ─────────────────────────────────────────────────────────────────────────────

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface PessoaSessao {
  id: string;
  nomeCompleto: string;
  email: string | null;
  telefonePrincipal: string;
  papeis: string[];
}

export interface TenantResumo {
  id: string;
  nomeImobiliaria: string;
}

interface PessoaAuthState {
  pessoa: PessoaSessao | null;
  tenant: TenantResumo | null;
  accessToken: string | null;
  refreshToken: string | null;
  expiresAt: Date | null;
  isAuthenticated: boolean;

  setAuth: (params: {
    pessoa: PessoaSessao;
    tenant: TenantResumo;
    accessToken: string;
    refreshToken: string;
    expiresAt: Date;
  }) => void;
  updateAccessToken: (accessToken: string, expiresAt: Date) => void;
  clearAuth: () => void;
}

export const usePessoaAuthStore = create<PessoaAuthState>()(
  persist(
    (set) => ({
      pessoa: null,
      tenant: null,
      accessToken: null,
      refreshToken: null,
      expiresAt: null,
      isAuthenticated: false,

      setAuth: ({ pessoa, tenant, accessToken, refreshToken, expiresAt }) => {
        set({ pessoa, tenant, accessToken, refreshToken, expiresAt, isAuthenticated: true });
      },

      updateAccessToken: (accessToken, expiresAt) => {
        set({ accessToken, expiresAt });
      },

      clearAuth: () => {
        set({
          pessoa: null,
          tenant: null,
          accessToken: null,
          refreshToken: null,
          expiresAt: null,
          isAuthenticated: false,
        });
      },
    }),
    {
      // Nome de storage diferente de 'aksape-auth' (o do useAuthStore) — são
      // duas chaves de localStorage completamente separadas.
      name: 'aksape-area-cliente-auth',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
